import React, { useEffect, useRef, useState } from 'react';
import '../styles/homeHeroSection.css';
import { Link } from 'react-router-dom';

export default function HomeHeroSection() {
  const videoRef = useRef(null);
  const [isWinter, setIsWinter] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const duration = video.duration || 0;
      const percent = duration ? video.currentTime / duration : 0;
      setIsWinter(percent >= 0.72);
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => video.removeEventListener('timeupdate', handleTimeUpdate);
  }, []);

  return (
    <section className="home-hero-section text-center">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="home-hero-video"
        ref={videoRef}
      >
        <source src="/videos/aSeasonsVideo2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className={`home-hero-overlay-content ${isWinter ? 'winter-text-overlay' : ''}`}>
        <div className="home-hero-logo-line">
          <h1>
            <span className="inline-logo-wrap">
              {/* <img
                src="/images/LeafASL.png"
                alt="All Seasons Tree Logo"
                className="home-hero-logo-inline"
                loading="eager"
                decoding="async"
              /> */}
              <span className="hero-text">All Services. All Seasons.</span>
            </span>
            {/* Changed from <div> to <span className="hero-tagline"> for better inline/line-box behavior */}
            <span className="hero-tagline">All Over The Wood River Valley</span>
          </h1>
        </div>

        <p className="home-hero-subheading">
          Landscaping design and build, custom maintenance programs, snow removal and more
        </p>

        <div style={{ marginTop: '1rem' }}>
          <Link to="mailto:info@allseasons.info">
            <button
              className="btn-cta"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textTransform: 'uppercase' }}
            >
              Request a Consultation
            </button>
          </Link>

          <Link to="/Gallery">
            <button
              className="btn-primary"
              style={{ textTransform: 'uppercase', marginLeft: '1rem' }}
            >
              View Our Work
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
